import { Badge } from "baseui/badge"
import { FormattedMessage } from "react-intl"

const AggregateOpenCloseText = (props: { isOn: boolean }) => {

    return (<>
        {props.isOn && <Badge hierarchy='secondary' color='positive' content={<FormattedMessage id="Devices.OPEN" defaultMessage="OPEN" />} />}
        {!props.isOn && <Badge hierarchy='secondary' color='primary' content={<FormattedMessage id="Devices.CLOSED" defaultMessage="CLOSED" />} />}
    </>)
}

export default AggregateOpenCloseText;